(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[177],{

/***/ "DS8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-placeholder/ImagePlaceholder.jsx
var ImagePlaceholder = __webpack_require__("D0nZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-icon/AdditionItemIcon.themes.js
var themes = {
  "default": {
    thItemIcon: 'flex items-center justify-center h-full text-black',
    thItemIconSize: '75%',
    thItemLabel: 'font-bold inline-flex gap-5 items-center mt-10 text-14 text-black'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-icon/AdditionItemIcon.jsx
var __jsx = react_default.a.createElement;






var AdditionItemIcon_AdditionItemIcon = function AdditionItemIcon(_ref) {
  var alt = _ref.alt,
      iconName = _ref.iconName,
      label = _ref.label,
      symbol = _ref.symbol,
      _ref$ratioKey = _ref.ratioKey,
      ratioKey = _ref$ratioKey === void 0 ? ratios_utils["c" /* default */].XL : _ref$ratioKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!iconName) {
    return null;
  }

  var _themes$theme = themes[theme],
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconSize = _themes$theme.thItemIconSize,
      thItemLabel = _themes$theme.thItemLabel;
  return __jsx(react["Fragment"], null, __jsx(ImagePlaceholder["a" /* ImagePlaceholder */], {
    aspectRatio: 100 * ratios_utils["c" /* default */].VALUES[ratioKey]
  }, __jsx("span", {
    className: thItemIcon
  }, __jsx(Icon["a" /* Icon */], {
    name: iconName,
    isNotSquare: true,
    width: thItemIconSize
  })), symbol), alt && __jsx("span", {
    className: "sr-only"
  }, alt, " "), !!label && __jsx("span", {
    className: thItemLabel,
    "data-testid": "AdditionItemIcon-label"
  }, label, __jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "1em"
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-image/AdditionItemImage.themes.js
var AdditionItemImage_themes_themes = {
  "default": {
    thItem: 'flex-none relative',
    thItemImage: 'overflow-hidden rounded-12',
    thItemLabel: 'flex font-bold gap-5 items-baseline leading-normal mt-10 overflow-hidden text-14 text-black',
    thItemLabelIcon: 'mt-1 shrink-0 text-sienna',
    thItemLabelIconSize: '1em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-image/AdditionItemImage.jsx
var AdditionItemImage_jsx = react_default.a.createElement;






var AdditionItemImage_AdditionItemImage = function AdditionItemImage(_ref) {
  var _ref$image = _ref.image,
      image = _ref$image === void 0 ? {} : _ref$image,
      label = _ref.label,
      symbol = _ref.symbol,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 0.5 : _ref$ratioDisplay,
      _ref$ratioKey = _ref.ratioKey,
      ratioKey = _ref$ratioKey === void 0 ? ratios_utils["c" /* default */].XL : _ref$ratioKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!image.src) {
    return null;
  }

  var _themes$theme = AdditionItemImage_themes_themes[theme],
      thItem = _themes$theme.thItem,
      thItemImage = _themes$theme.thItemImage,
      thItemLabel = _themes$theme.thItemLabel,
      thItemLabelIcon = _themes$theme.thItemLabelIcon,
      thItemLabelIconSize = _themes$theme.thItemLabelIconSize;
  return AdditionItemImage_jsx(react["Fragment"], null, AdditionItemImage_jsx("div", {
    className: thItem
  }, AdditionItemImage_jsx(Image["b" /* default */], {
    altMsg: image.alt,
    className: thItemImage,
    imageUrl: image.src,
    ratioDisplay: ratioDisplay,
    ratioKey: ratioKey
  }), symbol), !!label && AdditionItemImage_jsx("p", {
    className: thItemLabel,
    "data-testid": "AdditionItemImage-label"
  }, AdditionItemImage_jsx(Icon["a" /* Icon */], {
    className: thItemLabelIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thItemLabelIconSize
  }), label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/Addition.themes.js
var Addition_themes_themes = {
  "default": {
    thList: 'flex gap-20 isolate relative max-w-full',
    thItem: 'flex-1 flex flex-col items-stretch relative',
    thSymbol: 'size-46 absolute bg-white flex font-bold items-center justify-center leading-0 -mx-10 p-10 right-0 rounded-full text-black text-24 top-1/2 transform ltr:translate-x-1/2 rtl:-translate-x-1/2 -translate-y-1/2 z-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/Addition.jsx











var Addition_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Addition_Addition = function Addition(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      ratioKey = _ref.ratioKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var filteredItems = items.filter(function (_ref2) {
    var _ref2$icon = _ref2.icon,
        icon = _ref2$icon === void 0 ? {} : _ref2$icon,
        _ref2$image = _ref2.image,
        image = _ref2$image === void 0 ? {} : _ref2$image;
    return icon.name || image.src;
  });

  if (!filteredItems.length) {
    return null;
  }

  var _themes$theme = Addition_themes_themes[theme],
      thItem = _themes$theme.thItem,
      thList = _themes$theme.thList,
      thSymbol = _themes$theme.thSymbol;
  var width = 100 / filteredItems.length;
  return Addition_jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])(thList, className)
  }, filteredItems.map(function (_ref3, idx) {
    var _ref3$icon = _ref3.icon,
        icon = _ref3$icon === void 0 ? {} : _ref3$icon,
        image = _ref3.image,
        label = _ref3.label,
        _ref3$link = _ref3.link,
        link = _ref3$link === void 0 ? {} : _ref3$link;
    var isLink = !!link.url;
    var TagName = isLink ? DynamicLink["a" /* default */] : react["Fragment"];
    var tagProps = isLink ? _objectSpread(_objectSpread({}, link), {}, {
      className: 'block'
    }) : null;
    var symbol = idx < filteredItems.length - 1 ? Addition_jsx("div", {
      className: thSymbol
    }, idx === filteredItems.length - 2 ? '=' : '+') : null;
    return Addition_jsx("li", {
      className: thItem,
      key: label
    }, Addition_jsx(TagName, tagProps, icon.name ? Addition_jsx(AdditionItemIcon_AdditionItemIcon, {
      alt: icon.alt,
      iconName: icon.name,
      label: label,
      ratioKey: ratioKey,
      symbol: symbol,
      theme: theme
    }) : Addition_jsx(AdditionItemImage_AdditionItemImage, {
      image: image,
      label: label,
      ratioKey: ratioKey,
      ratioDisplay: width / 100,
      symbol: symbol,
      theme: theme
    })));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/all-inclusive-push/AllInclusivePush.jsx




var AllInclusivePush_jsx = react_default.a.createElement;






var AllInclusivePush_AllInclusivePush = function AllInclusivePush(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!items.length) {
    return null;
  }

  var filteredItems = items.filter(function (item) {
    return item.label || item.icon;
  });

  var _ref2 = filteredItems.pop() || {},
      _ref2$icon = _ref2.icon,
      lastIcon = _ref2$icon === void 0 ? {} : _ref2$icon,
      _ref2$label = _ref2.label,
      lastLabel = _ref2$label === void 0 ? '' : _ref2$label,
      _ref2$link = _ref2.link,
      lastLink = _ref2$link === void 0 ? {} : _ref2$link;

  return isTablet ? AllInclusivePush_jsx(Addition_Addition, {
    items: items
  }) : AllInclusivePush_jsx("ul", {
    className: "space-y-10"
  }, filteredItems.map(function (_ref3) {
    var label = _ref3.label;
    return AllInclusivePush_jsx("li", {
      className: "flex items-center gap-10 text-14 font-bold text-black",
      key: label
    }, AllInclusivePush_jsx(Icon["a" /* Icon */], {
      className: "text-sienna",
      name: icons["a" /* ICONS */].CHECK,
      width: "1em"
    }), label);
  }), AllInclusivePush_jsx("li", {
    className: "flex flex-col gap-10"
  }, AllInclusivePush_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    isNotSquare: true,
    name: lastIcon.name,
    width: "40%"
  }), lastIcon.alt && AllInclusivePush_jsx("span", {
    className: "sr-only"
  }, lastIcon.alt, " "), AllInclusivePush_jsx(TextLink["a" /* TextLink */], {
    className: "self-end underline",
    label: lastLabel,
    url: lastLink.url
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/all-inclusive-push-line/AllInclusivePushLine.jsx




var AllInclusivePushLine_jsx = react_default.a.createElement;




var AllInclusivePushLine_AllInclusivePushLine = function AllInclusivePushLine(_ref) {
  var id = _ref.id,
      _ref$lastItem = _ref.lastItem,
      lastItem = _ref$lastItem === void 0 ? {} : _ref$lastItem,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      title = _ref.title;

  if (!items.length) {
    return null;
  }

  return AllInclusivePushLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "allInclusive",
    id: id
  }, AllInclusivePushLine_jsx(LineTitle["a" /* LineTitle */], null, title), AllInclusivePushLine_jsx(AllInclusivePush_AllInclusivePush, {
    items: [].concat(Object(toConsumableArray["a" /* default */])(items.map(function (item) {
      return {
        image: {
          alt: '',
          src: item.mediaUrl
        },
        label: item.label,
        link: {
          url: item.link
        }
      };
    })), [{
      icon: {
        alt: lastItem.mediaAlt,
        name: lastItem.icon
      },
      label: lastItem.label,
      link: {
        url: lastItem.link
      }
    }])
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/all-inclusive-push/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (AllInclusivePushLine_AllInclusivePushLine);

/***/ })

}]);